import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { camelizeObject } from '@cvt/helpers/object';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getOngoingSession = (): AxiosPromise<CVT.MaybeNull<Feedback.Session>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/feedback-sessions/ongoing/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<CVT.MaybeNull<Feedback.SessionApi>>) => ({
    ...data,
    data: data.data ? camelizeObject<Feedback.Session>(data.data) : null,
  }));
};

const answerQuestion = (params: {
  sessionId: number;
  questionId: number;
  answer: Feedback.AnswerValue;
}): AxiosPromise<Feedback.AnswerResponse> => {
  return request({
    options: {
      url: `${apiBaseUrl}/feedback-sessions/${params.sessionId}/answer/`,
      method: 'POST',
      data: {
        question_id: params.questionId,
        value: params.answer,
      },
    },
  }).then((data: AxiosResponse<Feedback.AnswerResponseApi>) => ({
    ...data,
    data: camelizeObject<Feedback.AnswerResponse>(data.data),
  }));
};

export const feedbackClient = {
  getOngoingSession,
  answerQuestion,
};
